// Mobile hamburger + desktop tabs for AppBarHeader (lint split).
import { useState } from 'react';
import { Tabs, Tab, IconButton, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

export function AppBarNav({ isDesktop, tab, visiblePages, onTabChange, t, sx }) {
  const [navAnchor, setNavAnchor] = useState(null);
  const navMenuLabel = t('appbar.navMenu', 'Navigation menu');

  if (isDesktop) {
    return (
      <Tabs
        value={tab}
        onChange={onTabChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{ minHeight: 32, ...sx }}
      >
        {visiblePages.map((p) => (
          <Tab
            key={p.path}
            label={t(p.labelKey, p.fallback)}
            sx={{ minHeight: 32, py: 0 }}
          />
        ))}
      </Tabs>
    );
  }

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => setNavAnchor(e.currentTarget)}
        aria-label={navMenuLabel}
        aria-haspopup="menu"
        aria-expanded={Boolean(navAnchor)}
        sx={sx}
      >
        <MenuIcon sx={{ fontSize: 22 }} aria-hidden="true" />
      </IconButton>
      <Menu
        anchorEl={navAnchor}
        open={Boolean(navAnchor)}
        onClose={() => setNavAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {visiblePages.map((p, index) => (
          <MenuItem
            key={p.path}
            selected={tab === index}
            aria-selected={tab === index ? 'true' : 'false'}
            onClick={() => {
              onTabChange(null, index);
              setNavAnchor(null);
            }}
          >
            {t(p.labelKey, p.fallback)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
